import mkNodes from './Nodes'
import mkPipedrive from './Pipedrive'
import mkZendesk from './Zendesk'

const mkModelsConfig = () => ({
  nodes: {
    factory: ({ request }) =>
      // @ts-expect-error@2554
      mkNodes({
        request,
        contentfulBaseUrl: global.CONTENTFUL_BASE_URI,
        contentfulNodesApiKey: global.CONTENTFUL_NODES_API_KEY,
        contentfulNodesSpaceId: global.CONTENTFUL_NODES_SPACE_ID,
      })(),
  },
  zendesk: {
    factory: ({ request }) =>
      // @ts-expect-error@2554
      mkZendesk({
        request,
        zendeskBaseUrl: global.BASE_URLS.zendesk,
      })(),
  },
  pipedrive: {
    factory: ({ request }) =>
      // @ts-expect-error@2554
      mkPipedrive({
        request,
        pipedriveBaseUrl: global.BASE_URLS.pipedrive,
      })(),
  },
})

export default mkModelsConfig
